import ShippingList from '@/components/Shipping/ShippingList'
import ShippingForm from '@/components/Shipping/ShippingForm'
import ShippingDetail from '@/components/Shipping/ShippingDetail'

let ShippingRouter = [{
  path: '/shipping',
  name: 'ShippingList',
  component: ShippingList,
  meta: {
    title: 'Expéditions',
    requiresAuth: true,
    authorizations: ['shipping_index', 'desktop_access']
  }
}, {
  path: '/shipping/status/:status',
  name: 'ShippingListByStatus',
  component: ShippingList,
  meta: {
    title: 'Expéditions',
    requiresAuth: true,
    authorizations: ['shipping_index', 'desktop_access']
  }
}, {
  path: '/shipping/new',
  name: 'ShippingNew',
  component: ShippingForm,
  meta: {
    title: 'Nouvelle expédition',
    requiresAuth: true,
    authorizations: ['shipping_new', 'desktop_access']
  }
}, {
  path: '/shipping/:id/edit',
  name: 'ShippingEdit',
  component: ShippingForm,
  meta: {
    title: 'Modifier une expédition',
    requiresAuth: true,
    authorizations: ['shipping_edit', 'desktop_access']
  }
}, {
  path: '/shipping/:id',
  name: 'ShippingDetail',
  component: ShippingDetail,
  meta: {
    title: 'Fiche expédition',
    requiresAuth: true,
    authorizations: ['shipping_show', 'desktop_access']
  }
}]

export default ShippingRouter



// WEBPACK FOOTER //
// ./src/components/Shipping/router.js